<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-text v-if="title">
        <h2 class="text-sm-center subheading">
          {{ title }}
        </h2>
      </v-card-text>
      <v-card-text v-if="hasDefaultSlot">
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="onCancel"
        >
          Cancel
        </v-btn>
        <v-btn
          color="error"
          text
          @click="onConfirm"
        >
          Confirm
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
  methods: {
    onConfirm() {
      this.$emit('on-confirm');
      this.dialog = false;
    },
    onCancel() {
      this.$emit('on-cancel');
      this.dialog = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ConfirmModal.vue